import React, { useState, useEffect } from "react";
import rewardIcon from "../../assets/images/reward.svg";
import bonus2 from "../../assets/images/bonus_2.png";
import EVERY_DEPOSIT_BONUS from "../../assets/images/EVERY_DEPOSIT_BONUS.jpg";
import "./bonus.css";
import {
  getBonusesAmountsAsync,
  getLockedBonusProgressAsync,
} from "../../store/slices/bonusSlice";
import { useDispatch, useSelector } from "react-redux";

const TABS = [
  { id: "all", label: "All" },
  { id: "active", label: "Active" },
  { id: "inactive", label: "InActive" },
  { id: "claimed", label: "Claimed" },
];

const normalizeStatusStr = (statusStr) =>
  String(statusStr || "")
    .trim()
    .toUpperCase();

const getStatusLabel = (statusStr) => {
  const s = normalizeStatusStr(statusStr);
  if (s === "ACTIVE") return "Active Bonus";
  if (s === "INACTIVE") return "Inactive Bonus";
  if (s === "COMPLETED") return "Claimed Bonus";
  return s ? `${s} Bonus` : "Bonus";
};

const formatBonusTitle = (bonusType) =>
  String(bonusType || "")
    .replace(/_/g, " ")
    .trim()
    .toUpperCase() || "BONUS";

const filterBonusesByTab = (tabId, list) => {
  const bonuses = Array.isArray(list) ? list : [];
  if (tabId === "all") return bonuses;
  if (tabId === "active")
    return bonuses.filter(
      (b) => normalizeStatusStr(b?.status_str) === "ACTIVE",
    );
  if (tabId === "inactive")
    return bonuses.filter(
      (b) => normalizeStatusStr(b?.status_str) === "INACTIVE",
    );
  if (tabId === "claimed")
    return bonuses.filter(
      (b) => normalizeStatusStr(b?.status_str) === "COMPLETED",
    );
  return bonuses;
};

const BonusList = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedBonus, setSelectedBonus] = useState(null);
  const [promoCode, setPromoCode] = useState("");

  const [lockedBonusProgress, setLockedBonusProgress] = useState([]);
  const activeIndex = TABS.findIndex((t) => t.id === activeTab);

  const dispatch = useDispatch();

  const bonusAmounts = useSelector((state) => state?.bonus?.bonusAmounts || []);
  const loading = useSelector((state) => state?.bonus?.loading || false);
  const error = useSelector((state) => state?.bonus?.error || null);

  const getLockedBonusProgress = async () => {
    const res = await dispatch(getLockedBonusProgressAsync()).unwrap();
    setLockedBonusProgress(res || []);
  };

  const handleRedeemRefresh = async () => {
    await Promise.all([
      dispatch(getBonusesAmountsAsync()),
      getLockedBonusProgress(),
    ]);
  };

  useEffect(() => {
    dispatch(getBonusesAmountsAsync());
    getLockedBonusProgress();
  }, [dispatch]);

  const openBonusDialog = (bonus) => {
    setSelectedBonus(bonus);
    setDialogOpen(true);
  };

  const closeBonusDialog = () => {
    setDialogOpen(false);
    setSelectedBonus(null);
  };

  useEffect(() => {
    if (!dialogOpen) return;
    const handleEscape = (e) => {
      if (e.key === "Escape") closeBonusDialog();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [dialogOpen]);

  return (
    <div className="bonuses-root">
      <div className="card-body card-content p-0">
        <div className="bet-table-header">
          <div className="row align-items-center g-0">
            <div className="col-md-6">
              <span className="list-sport-title"> Bonus List</span>
            </div>
          </div>
        </div>
        <div className="bet-table-body">
          <div className="home-products-container mt-1">
            <div className="row row5 g-0">
              <div className="col-md-12">
                <div className="bonuses-inner">
                  <div
                    className={`bonuses-tabs pill-${activeIndex >= 0 ? activeIndex : 0}`}
                  >
                    {TABS.map((tab, index) => (
                      <div
                        key={tab.id}
                        className={`bonuses-tab ${activeTab === tab.id ? "bonuses-tab-active" : "bonuses-tab-inactive"}`}
                        onClick={() => setActiveTab(tab.id)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            setActiveTab(tab.id);
                          }
                        }}
                        role="tab"
                        aria-selected={activeTab === tab.id}
                        tabIndex={0}
                      >
                        <span>{tab.label}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bonuses-content d-none ">
                  <div className="bonuses-gift-card">
                    <div className="bonuses-gift-card-deco">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="67"
                        height="16"
                        viewBox="0 0 67 16"
                        fill="none"
                      >
                        <path
                          d="M67 0H0L3.31268 5.64947C8.18926 13.966 18.3048 17.62 27.3705 14.3397L67 0Z"
                          fill="var(--icon-color-secondary)"
                          fillOpacity="0.15"
                        />
                      </svg>
                    </div>
                    <div className="bonuses-gift-card-body">
                      <img
                        alt="ReddemCodeGift"
                        loading="lazy"
                        width="104"
                        height="97.12"
                        decoding="async"
                        className="bonuses-gift-card-img"
                        src={rewardIcon}
                      />
                      <div className="bonuses-gift-card-text">
                        <div className="bonuses-gift-card-title">GIFT CARD</div>
                        <div className="bonuses-gift-card-desc">
                          Type or Paste your promocode and get rewards in your
                          wallet.
                        </div>
                      </div>
                    </div>
                    <div className="bonuses-gift-card-input-wrap">
                      <div className="bonuses-gift-card-input-row">
                        <input
                          placeholder="Enter Promo Code"
                          value={promoCode}
                          onChange={(e) => setPromoCode(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") handleRedeemRefresh();
                          }}
                        />
                        <div className="bonuses-redeem-btn-wrap">
                          <button
                            type="button"
                            className="bonuses-redeem-btn"
                            onClick={handleRedeemRefresh}
                          >
                            <span>REDEEM</span>
                          </button>
                        </div>
                      </div>
                      <div className="bonuses-gift-card-extra">
                        <div />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bonuses-content">
                  {TABS.map((tab) => {
                    const bonuses = filterBonusesByTab(
                      tab.id,
                      lockedBonusProgress,
                    );

                    return (
                      <div
                        key={tab.id}
                        className={`bonuses-tab-panel ${activeTab === tab.id ? "is-active" : ""}`}
                        role="tabpanel"
                        aria-hidden={activeTab !== tab.id}
                      >
                        <div className="bonuses-grid">
                          {loading && activeTab === tab.id ? (
                            <div className="main-bonus-container deposit-wrrap">
                              <div className="expired font-semibold plus-bg-green-500">
                                <div className="shimmer-animation" />
                                Loading...
                              </div>
                            </div>
                          ) : null}
                          {bonuses.map((bonus) => (
                            <div
                              key={
                                bonus?._id ||
                                `${bonus?.bonus_type || "bonus"}-${bonus?.created_at || ""}`
                              }
                              className="main-bonus-container deposit-wrrap"
                            >
                              <div className="expired font-semibold plus-bg-green-500">
                                <div className="shimmer-animation" />
                                {bonus?.status_str}
                              </div>
                              <div
                                title={formatBonusTitle(bonus?.bonus_type)}
                                aria-label={formatBonusTitle(bonus?.bonus_type)}
                                className="bonuses-card"
                                onClick={() => openBonusDialog(bonus)}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    e.preventDefault();
                                    openBonusDialog(bonus);
                                  }
                                }}
                                role="button"
                                tabIndex={0}
                              >
                                <div className="bonuses-card-bg">
                                  <div className="bonuses-card-bg-inner">
                                    <img
                                      src={bonus2}
                                      alt="150% deposit bonus & 10% free cash"
                                      sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 625px"
                                      loading="eager"
                                      width="300"
                                      height="150"
                                    />
                                  </div>
                                </div>
                                <p className="bonuses-card-title">
                                  {formatBonusTitle(bonus?.bonus_type)}
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {dialogOpen && (
        <div
          className="bonuses-dialog-overlay"
          onClick={closeBonusDialog}
          role="dialog"
          aria-modal="true"
          aria-labelledby="bonus-dialog-title"
        >
          <div
            className="bonuses-dialog bonus-detail"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="bonus-detail-header">
              <span className="bonus-detail-code">usab2c</span>
              <button
                type="button"
                className="bonus-detail-close-button"
                onClick={closeBonusDialog}
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 16 16"
                  fill="var(--icon-color-secondary)"
                  className="bonus-detail-close-icon"
                >
                  <g clipPath="url(#clip0_406_1676)">
                    <path
                      d="M9.46585 8.01314L15.6959 1.78287C16.1014 1.37762 16.1014 0.722377 15.6959 0.317124C15.2907 -0.0881297 14.6354 -0.0881297 14.2302 0.317124L7.99991 6.5474L1.76983 0.317124C1.36438 -0.0881297 0.709336 -0.0881297 0.304082 0.317124C-0.101361 0.722377 -0.101361 1.37762 0.304082 1.78287L6.53416 8.01314L0.304082 14.2434C-0.101361 14.6487 -0.101361 15.3039 0.304082 15.7092C0.506045 15.9113 0.771595 16.0129 1.03695 16.0129C1.30232 16.0129 1.56768 15.9113 1.76983 15.7092L7.99991 9.47889L14.2302 15.7092C14.4323 15.9113 14.6977 16.0129 14.9631 16.0129C15.2284 16.0129 15.4938 15.9113 15.6959 15.7092C16.1014 15.3039 16.1014 14.6487 15.6959 14.2434L9.46585 8.01314Z"
                      fill="var(--icon-color-secondary)"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_406_1676">
                      <rect
                        width="16"
                        height="16"
                        fill="var(--icon-color-secondary)"
                      ></rect>
                    </clipPath>
                  </defs>
                </svg>
              </button>
            </div>
            <img
              src={EVERY_DEPOSIT_BONUS}
              alt="EVERY_DEPOSIT_BONUS"
              className="bonus-detail-image"
            />
            <div className="bonus-detail-body">
              <h3 className="bonus-detail-title">
                {formatBonusTitle(selectedBonus?.bonus_type) ||
                  "EVERY DEPOSIT BONUS"}
              </h3>
              <div className="bonus-detail-row">
                <span className="bonus-detail-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#bd3726"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="bonus-detail-icon"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M9 14c0 1.657 2.686 3 6 3s6 -1.343 6 -3s-2.686 -3 -6 -3s-6 1.343 -6 3z"></path>
                    <path d="M9 14v4c0 1.656 2.686 3 6 3s6 -1.344 6 -3v-4"></path>
                    <path d="M3 6c0 1.072 1.144 2.062 3 2.598s4.144 .536 6 0c1.856 -.536 3 -1.526 3 -2.598c0 -1.072 -1.144 -2.062 -3 -2.598s-4.144 -.536 -6 0c-1.856 .536 -3 1.526 -3 2.598z"></path>
                    <path d="M3 6v10c0 .888 .772 1.45 2 2"></path>
                    <path d="M3 11c0 .888 .772 1.45 2 2"></path>
                  </svg>
                  <span>
                    Rolling Multiplier :{" "}
                    {selectedBonus?.rolling_multiplier ?? 0}
                  </span>
                </span>
                <span className="bonus-detail-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#bd3726"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="bonus-detail-icon"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M9 14c0 1.657 2.686 3 6 3s6 -1.343 6 -3s-2.686 -3 -6 -3s-6 1.343 -6 3z"></path>
                    <path d="M9 14v4c0 1.656 2.686 3 6 3s6 -1.344 6 -3v-4"></path>
                    <path d="M3 6c0 1.072 1.144 2.062 3 2.598s4.144 .536 6 0c1.856 -.536 3 -1.526 3 -2.598c0 -1.072 -1.144 -2.062 -3 -2.598s-4.144 -.536 -6 0c-1.856 .536 -3 1.526 -3 2.598z"></path>
                    <path d="M3 6v10c0 .888 .772 1.45 2 2"></path>
                    <path d="M3 11c0 .888 .772 1.45 2 2"></path>
                  </svg>
                  <p className="bonus-detail-text">
                    Total Rolling Amount :{" "}
                    {selectedBonus?.total_rolling_amount ?? 0}
                  </p>
                </span>
              </div>
              <div className="bonus-detail-row">
                <span className="bonus-detail-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#bd3726"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="bonus-detail-icon"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M9 14c0 1.657 2.686 3 6 3s6 -1.343 6 -3s-2.686 -3 -6 -3s-6 1.343 -6 3z"></path>
                    <path d="M9 14v4c0 1.656 2.686 3 6 3s6 -1.344 6 -3v-4"></path>
                    <path d="M3 6c0 1.072 1.144 2.062 3 2.598s4.144 .536 6 0c1.856 -.536 3 -1.526 3 -2.598c0 -1.072 -1.144 -2.062 -3 -2.598s-4.144 -.536 -6 0c-1.856 .536 -3 1.526 -3 2.598z"></path>
                    <path d="M3 6v10c0 .888 .772 1.45 2 2"></path>
                    <path d="M3 11c0 .888 .772 1.45 2 2"></path>
                  </svg>
                  <span>
                    Used Rolling Amount :{" "}
                    {selectedBonus?.used_rolling_amount ?? 0}
                  </span>
                </span>
                <span className="bonus-detail-item">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#bd3726"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="bonus-detail-icon"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M9 14c0 1.657 2.686 3 6 3s6 -1.343 6 -3s-2.686 -3 -6 -3s-6 1.343 -6 3z"></path>
                    <path d="M9 14v4c0 1.656 2.686 3 6 3s6 -1.344 6 -3v-4"></path>
                    <path d="M3 6c0 1.072 1.144 2.062 3 2.598s4.144 .536 6 0c1.856 -.536 3 -1.526 3 -2.598c0 -1.072 -1.144 -2.062 -3 -2.598s-4.144 -.536 -6 0c-1.856 .536 -3 1.526 -3 2.598z"></path>
                    <path d="M3 6v10c0 .888 .772 1.45 2 2"></path>
                    <path d="M3 11c0 .888 .772 1.45 2 2"></path>
                  </svg>
                  <p className="bonus-detail-text">
                    Total Locked Bonus Amount :{" "}
                    {selectedBonus?.total_locked_bonus_amount ?? 0}
                  </p>
                </span>
              </div>
              <span className="bonus-detail-item bonus-detail-note">
                <svg
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="bonus-detail-icon"
                >
                  <g clipPath="url(#clip0_1717_31141)">
                    <path
                      d="M8.5 0.5C4.07841 0.5 0.5 4.078 0.5 8.5C0.5 12.9215 4.078 16.5 8.5 16.5C12.9216 16.5 16.5 12.922 16.5 8.5C16.5 4.07847 12.922 0.5 8.5 0.5ZM8.5 15.3837C4.70431 15.3837 1.61628 12.2957 1.61628 8.5C1.61628 4.70428 4.70431 1.61628 8.5 1.61628C12.2957 1.61628 15.3837 4.70428 15.3837 8.5C15.3837 12.2957 12.2957 15.3837 8.5 15.3837Z"
                      fill="#C10B32"
                    ></path>
                    <path
                      d="M8.5003 7.1687C8.02642 7.1687 7.68945 7.36883 7.68945 7.66367V11.6757C7.68945 11.9285 8.02642 12.1812 8.5003 12.1812C8.95311 12.1812 9.32164 11.9285 9.32164 11.6757V7.66361C9.32164 7.36879 8.95311 7.1687 8.5003 7.1687Z"
                      fill="#C10B32"
                    ></path>
                    <path
                      d="M8.50019 4.69409C8.01578 4.69409 7.63672 5.04159 7.63672 5.44175C7.63672 5.84194 8.01581 6.19997 8.50019 6.19997C8.97406 6.19997 9.35319 5.84194 9.35319 5.44175C9.35319 5.04159 8.97403 4.69409 8.50019 4.69409Z"
                      fill="#C10B32"
                    ></path>
                  </g>
                  <defs>
                    <clipPath id="clip0_1717_31141">
                      <rect
                        width="16"
                        height="16"
                        fill="white"
                        transform="translate(0.5 0.5)"
                      ></rect>
                    </clipPath>
                  </defs>
                </svg>
                <p className="bonus-detail-text">
                  Unlocked Bonus Amount :{" "}
                  {selectedBonus?.unlocked_bonus_amount ?? 0}
                </p>
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BonusList;
